import dotenv from 'dotenv'
dotenv.config()

export default class Configuration {
  static CONFIG = {
    cloudAppsAPIHost: '$VUE_APP_CLOUD_APPS_API_HOST',
    backendProtocol: '$VUE_APP_BACKEND_PROTOCOL',
    authRedirectUrl: '$VUE_APP_CP_AUTH_REDIRECT_URL',
    authClientId: '$VUE_APP_CP_AUTH_CLIENT_ID',
    authClientSecret: '$VUE_APP_CP_AUTH_CLIENT_SECRET',
    aws_identity_pool_id: '$VUE_APP_AWS_IDENTITY_POOL_ID',
    aws_identity_region: '$VUE_APP_AWS_IDENTITY_REGION',
    aws_s3_bucket_name: '$VUE_APP_AWS_S3_BUCKET_NAME',
    aws_s3_bucket_region: '$VUE_APP_AWS_S3_BUCKET_REGION',
    cloudAuthAPIHost: '$VUE_APP_CP_CLOUD_AUTH_API_HOST',
    cloudAuthAPIProtocol: '$VUE_APP_CP_CLOUD_AUTH_API_PROTOCOL',
    reorderFeatureIsEnabled: '$VUE_APP_REORDER_FEATURE_IS_ENABLED',
    cloudUserAPIHost: '$VUE_APP_CLOUD_USER_API_HOST'
  }

  static value (name) {
    if (!(name in this.CONFIG)) {
      console.log(`Configuration: There is no key named "${name}"`)
      return
    }

    const value = this.CONFIG[name]

    if (!value) {
      console.log(`Configuration: Value for "${name}" is not defined`)
      return
    }

    if (value.startsWith('$VUE_APP_')) {
      // value was not replaced, it seems we are in development.
      // Remove $ and get current value from process.env
      const envName = value.substr(1)
      const envValue = process.env[envName]
      if (envValue) {
        return envValue
      } else {
        console.log(`Configuration: Environment variable "${envName}" is not defined`)
      }
    } else {
      // value was already replaced, it seems we are in production.
      return value
    }
  }
}
